// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Compromissos_SaveResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /compromissos/save — CREATE path only.
 *
 * Update path now emits Compromissos_UpdateCompromissoResponse (a boolean
 * success flag). The conditional getDados() shape that used to live here
 * was Pattern 4 (`Dados = unknown`); splitting eliminated it.
 *
 * Default getDados() (Pattern 1) emits all 16 public properties as the
 * dados object — fields not set during the create path stay null.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Compromissos_SaveResponseDados {
compromisso_id?: number
compromisso_orcamento_id?: number
compromisso_franquia_id?: number
compromisso_operador_user_id?: string
compromisso_titulo?: string
compromisso_total?: string
compromisso_cor_fundo?: string
compromisso_data_hora_inicio?: string
compromisso_data_hora_fim?: string
compromisso_forma_pagamento?: number
compromisso_numero_parcelas?: number
compromisso_tipo?: number
compromisso_checkin?: string
compromisso_checkout?: string
compromisso_entrou_sem_problemas?: number
compromisso_data_cadastro?: string
}

export type Compromissos_SaveResponse = ApiResponse<Compromissos_SaveResponseDados>;

registerResponseContract('Compromissos_SaveResponse', {
  compromisso_id:                   { type: 'number',  required: false },
  compromisso_orcamento_id:         { type: 'number',  required: false },
  compromisso_franquia_id:          { type: 'number',  required: false },
  compromisso_operador_user_id:     { type: 'string',  required: false },
  compromisso_titulo:               { type: 'string',  required: false },
  compromisso_total:                { type: 'string',  required: false },
  compromisso_cor_fundo:            { type: 'string',  required: false },
  compromisso_data_hora_inicio:     { type: 'string',  required: false },
  compromisso_data_hora_fim:        { type: 'string',  required: false },
  compromisso_forma_pagamento:      { type: 'number',  required: false },
  compromisso_numero_parcelas:      { type: 'number',  required: false },
  compromisso_tipo:                 { type: 'number',  required: false },
  compromisso_checkin:              { type: 'string',  required: false },
  compromisso_checkout:             { type: 'string',  required: false },
  compromisso_entrou_sem_problemas: { type: 'number',  required: false },
  compromisso_data_cadastro:        { type: 'string',  required: false },
})
